import React from "react";

interface IconProps {
  size?: number;
  style?: React.CSSProperties;
}

export const DashIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="2" width="6" height="6" rx="1" />
    <rect x="10" y="2" width="6" height="6" rx="1" />
    <rect x="2" y="10" width="6" height="6" rx="1" />
    <rect x="10" y="10" width="6" height="6" rx="1" />
  </svg>
);

export const CasesIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="5" width="14" height="11" rx="1.5" />
    <path d="M6 5V3.5A1.5 1.5 0 0 1 7.5 2h3A1.5 1.5 0 0 1 12 3.5V5" />
    <path d="M2 9h14" />
    <path d="M7 12h4" />
  </svg>
);

export const RulesIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M4 2h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
    <path d="M6 6h6M6 9h6M6 12h4" />
  </svg>
);

export const DocIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M10 2H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6l-4-4z" />
    <path d="M10 2v4h4" />
    <path d="M6 10h6M6 13h4" />
  </svg>
);

export const QuestIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="9" cy="9" r="7" />
    <path d="M7 7c0-1.1.9-2 2-2s2 .9 2 2c0 1.5-2 1.5-2 3" />
    <circle cx="9" cy="13.5" r=".5" fill="currentColor" />
  </svg>
);

export const AssessIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M4 2h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
    <path d="M6 7l2 2 4-4" />
    <path d="M6 12h6" />
  </svg>
);

export const SubsIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="4" width="14" height="10" rx="1.5" />
    <path d="M6 8h6M6 11h4" />
    <path d="M2 7h14" />
  </svg>
);

export const TeamIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="7" cy="6" r="3" />
    <path d="M1 16c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <circle cx="14" cy="6" r="2.5" />
    <path d="M17 16c0-2.5-1.3-4.6-3-5.5" />
  </svg>
);

export const AccountManagerIcon: React.FC<IconProps> = ({
  size = 18,
  style,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="7" cy="6" r="3" />
    <path d="M1.5 16c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6" />
    <circle cx="14" cy="12" r="3" />
    <path d="M12.3 12l1.2 1.2 2.2-2.4" />
  </svg>
);

export const AuditIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M9 2L2 6v6l7 4 7-4V6L9 2z" />
    <path d="M9 6v6M5.5 7.5l3.5 2 3.5-2" />
  </svg>
);

export const CostIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="9" cy="9" r="7" />
    <path d="M11.5 6.5c-.5-.8-1.5-1.2-2.5-1.2-1.4 0-2.5.8-2.5 2s1 1.6 2.5 1.9 2.5.7 2.5 1.9-1.1 2-2.5 2c-1 0-2-.4-2.5-1.2M9 4.2v1.1M9 12.7v1.1" />
  </svg>
);

export const CogIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="9" cy="9" r="2.5" />
    <path d="M9 1v2M9 15v2M1 9h2M15 9h2M3.05 3.05l1.41 1.41M13.54 13.54l1.41 1.41M3.05 14.95l1.41-1.41M13.54 4.46l1.41-1.41" />
  </svg>
);

export const BellIcon: React.FC<IconProps> = ({ size = 16, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M8 1a5 5 0 0 1 5 5v3l1 2H2l1-2V6a5 5 0 0 1 5-5z" />
    <path d="M6 13a2 2 0 0 0 4 0" />
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ size = 14, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="6" cy="6" r="4" />
    <path d="M9 9l3 3" />
  </svg>
);

export const ChevRightIcon: React.FC<IconProps> = ({ size = 10, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M3 2l4 3-4 3" />
  </svg>
);

export const MenuIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    style={style}
  >
    <path d="M2 4h14M2 9h14M2 14h14" />
  </svg>
);

export const XIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    style={style}
  >
    <path d="M4 4l10 10M14 4L4 14" />
  </svg>
);

export const LabelIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M2 9L9 2h7v7l-7 7-7-7z" />
    <circle cx="13" cy="5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const BugIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M9 5a4 4 0 0 0-4 4v1a4 4 0 0 0 8 0V9a4 4 0 0 0-4-4z" />
    <path d="M5 9H2M16 9h-3M5 12H3M15 12h-2M6 5l-2-2M12 5l2-2" />
    <path d="M7 3.5a2 2 0 0 1 4 0" />
  </svg>
);

export const LogoutIcon: React.FC<IconProps> = ({ size = 16, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M10 3h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-3" />
    <path d="M6 11l4-3-4-3" />
    <path d="M2 8h8" />
  </svg>
);

export const SettingsIcon: React.FC<IconProps> = ({ size = 16, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="8" cy="8" r="2" />
    <path d="M8 1v1.5M8 13.5V15M1 8h1.5M13.5 8H15M2.75 2.75l1 1M12.25 12.25l1 1M2.75 13.25l1-1M12.25 3.75l1-1" />
  </svg>
);

export const UploadIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M3 13v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2" />
    <path d="M9 2v10M5.5 5.5L9 2l3.5 3.5" />
  </svg>
);

export const ChecklistIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    {/* clipboard board */}
    <rect x="3" y="4" width="12" height="12" rx="1" />
    {/* clip tab */}
    <path d="M7 2h4v4H7z" />
    {/* check row 1 */}
    <path d="M7 9.5l1 1 2-2" />
    <path d="M12 9.5h2" />
    {/* check row 2 */}
    <path d="M7 12.5l1 1 2-2" />
    <path d="M12 12.5h2" />
  </svg>
);

export const QueueIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="3" width="14" height="3" rx="1" />
    <rect x="2" y="8" width="14" height="3" rx="1" />
    <rect x="2" y="13" width="9" height="3" rx="1" />
    <path d="M14 14.5l1.5-1.5 1 1" />
  </svg>
);

export const AMDashIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="2" width="6" height="6" rx="1" />
    <rect x="10" y="2" width="6" height="6" rx="1" />
    <rect x="2" y="10" width="6" height="6" rx="1" />
    <rect x="10" y="10" width="6" height="6" rx="1" />
  </svg>
);

export const AMCustomersIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="7" cy="6" r="3" />
    <path d="M1 16c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <circle cx="14" cy="6" r="2.5" />
    <path d="M17 16c0-2.5-1.3-4.6-3-5.5" />
  </svg>
);

export const AMTicketsIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M2 5h14v8H2z" rx="1" />
    <path d="M6 9h6M6 12h4" />
    <path d="M5 5V3.5A1.5 1.5 0 0 1 6.5 2h5A1.5 1.5 0 0 1 13 3.5V5" />
  </svg>
);

export const AMComplianceIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M9 1L2 4v5c0 4 3.1 7.4 7 8 3.9-.6 7-4 7-8V4L9 1z" />
    <path d="M6 9l2 2 4-4" />
  </svg>
);

export const AMAssessmentsIcon: React.FC<IconProps> = ({
  size = 18,
  style,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M4 2h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
    <path d="M6 7l2 2 4-4M6 12h6" />
  </svg>
);

export const AMBillingIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="4" width="14" height="10" rx="1.5" />
    <path d="M2 7h14" />
    <path d="M6 11h2" />
  </svg>
);

export const AMReportsIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M3 14V8l3-3 3 3 3-4 3 3v3" />
    <path d="M3 14h12" />
  </svg>
);

export const AMSettingsIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="9" cy="9" r="2.5" />
    <path d="M9 1v2M9 15v2M1 9h2M15 9h2M3.05 3.05l1.41 1.41M13.54 13.54l1.41 1.41M3.05 14.95l1.41-1.41M13.54 4.46l1.41-1.41" />
  </svg>
);

export const PanelLeftIcon: React.FC<IconProps> = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <rect x="2" y="2" width="14" height="14" rx="1.5" />
    <path d="M7 2v14" />
  </svg>
);

export const PinIcon: React.FC<IconProps> = ({ size = 12, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M6 1.5l2.25 2.25-.75.75 1.5 1.5-3 .75L4.5 9 3 7.5l1.25-1.5.75-3 1.5-1.5z" />
    <path d="M3 9l-1.5 1.5" />
  </svg>
);
